import React from 'react';
import TopStepAccountPage from './TopStepAccountPage';
import customerTopstepService from '../services/customerTopstepService';

const TopStepBotDashboardPage: React.FC = () => (
  <TopStepAccountPage
    accountLabel="TopStep Bot Dashboard"
    accountMatcher={(accounts) => accounts[0]}
    challengeParams={{ target: 4500, hardMax: 2000, internalStop: 1700, dailyCap: 600, accountSize: 50000 }}
    chipLabel="BOT"
    chipColor="#F44336"
    accountApi={customerTopstepService}
    datafeedApiBasePath="/customer/topstep"
  />
);

export default TopStepBotDashboardPage;